const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const baseURL = trimTrailingSlash(process.env.REACT_APP_BASE_URL || '')
const apiURL = trimTrailingSlash(process.env.REACT_APP_API_URL || '')
const chatURL = trimTrailingSlash(process.env.REACT_APP_CHAT_URL || baseURL)

const env = {
  baseURL,
  apiURL,
  chatURL,
  captchaKey: process.env.REACT_APP_CAPTCHA || '',
  defaultAdminId: Number.parseInt(process.env.REACT_APP_DEFAULT_ADMIN_ID || '0', 10),
  defaultAdminName: process.env.REACT_APP_DEFAULT_ADMIN_NAME || 'IPTU | Dívida ativa',
  defaultWelcomeMessage: process.env.REACT_APP_DEFAULT_WELCOME_MESSAGE || 'Por favor me diga o que você precisa',
}

export default env
